var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAudio(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2.5C4.68437 2.5 1.95 4.98125 1.55 8.1875C1.84375 8.06875 2.1625 8 2.5 8C3.32812 8 4 8.67188 4 9.5V13.5C4 14.3281 3.32812 15 2.5 15C1.11875 15 0 13.8813 0 12.5V12V10.5V9C0 4.58125 3.58125 1 8 1C12.4187 1 16 4.58125 16 9V10.5V12V12.5C16 13.8813 14.8813 15 13.5 15C12.6719 15 12 14.3281 12 13.5V9.5C12 8.67188 12.6719 8 13.5 8C13.8375 8 14.1562 8.06563 14.45 8.1875C14.05 4.98125 11.3156 2.5 8 2.5Z",
    fill: "#10B981"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAudio);
export default __webpack_public_path__ + "static/media/ic_audio.f19f4395975a5fe4e0443bf498492d4c.svg";
export { ForwardRef as ReactComponent };